const insuranceLandingView = require('./insuranceRequestView/insuranceLandingView/insuranceLandingView');
const insuranceRequestView = require('./insuranceRequestView/insuranceRequestView');
const insuranceRequestHomeView = require('./insuranceRequestView/insuranceRequestHomeView/insuranceRequestHomeView');
const insuranceRequestProductDetailDescriptionView = require('./insuranceRequestView/insuranceRequestProductDetailDescriptionView/insuranceRequestProductDetailDescriptionView');

module.exports = {
    insuranceLandingView,
    insuranceRequestView,
    insuranceRequestHomeView,
    insuranceRequestProductDetailDescriptionView
};
